import api from './api';

const getBrands = () => api.get('/brands');

export default {
	getBrands,
};
